var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-progress-linear',{attrs:{"color":"primary","indeterminate":"","rounded":"","height":"12"}}):_c('hotel-form',{attrs:{"hotel":_vm.hotel,"dialog-data":_vm.responseDialog},on:{"update:dialogData":function($event){_vm.responseDialog=$event},"update:dialog-data":function($event){_vm.responseDialog=$event},"finish":_vm.finish}})
}
var staticRenderFns = []

export { render, staticRenderFns }